import React, { useState, useRef, useLayoutEffect, ReactNode } from 'react';
import cls from 'classnames';
import SlideBtn from './components/SlideBtn';
import { slideHorizontal, MathRound } from '../slide';
import useBtnDisabledState from './hooks/useBtnDisabledState';
import './index.scss';

interface ISegmentAutoSlider {
  getParentNode: Function;
  children: ReactNode;
  allowBtnDisable?: boolean;
}

const SegmentAutoSlider: React.FC<ISegmentAutoSlider> = (props) => {
  const { getParentNode, allowBtnDisable } = props;

  const sliderWrapperRef = useRef<HTMLDivElement>(null);
  const [isSlideMode, setIsSlideMode] = useState(false);

  const [isAtLeft, isAtRight] = useBtnDisabledState(sliderWrapperRef, isSlideMode);

  const calculate = () => {
    if (!sliderWrapperRef.current) return true;

    const segmentListEl = sliderWrapperRef.current.querySelector('.tea-segment');
    if (!segmentListEl) return true;

    const totalWidth = MathRound(segmentListEl.scrollWidth);

    let parentNodeWidth = 0;
    if (getParentNode instanceof Function) {
      const parentNode = getParentNode();
      if (parentNode) {
        parentNodeWidth = MathRound(parentNode.clientWidth);
      }
    }

    if (!parentNodeWidth) {
      parentNodeWidth = MathRound(sliderWrapperRef.current.clientWidth);
    }

    return totalWidth > parentNodeWidth;
  };

  const handleSlide = (direction: 'left' | 'right') => {
    const distance = direction === 'left' ? 100 : -100;
    slideHorizontal(sliderWrapperRef.current, distance, 6);
  };

  const runCalculate = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setIsSlideMode(calculate());
      });
    });
  };

  const handleResize = () => {
    runCalculate();
  };

  useLayoutEffect(() => {
    setIsSlideMode(calculate());
    runCalculate();

    window.addEventListener('resize', handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize, false);
    };
  }, [props.children]);

  if (isSlideMode) {
    return (
      <div className="segment-slider-container">
        <SlideBtn
          className={cls('left-btn', { disabled: allowBtnDisable && isAtLeft })}
          direction="left"
          onClick={() => {
            if (allowBtnDisable && isAtLeft) {
              return;
            }
            handleSlide('right');
          }}
        />
        <div ref={sliderWrapperRef} className="segment-slider-wrapper">
          {props.children}
        </div>
        <SlideBtn
          className={cls('right-btn', { disabled: allowBtnDisable && isAtRight })}
          direction="right"
          onClick={() => {
            if (allowBtnDisable && isAtRight) {
              return;
            }
            handleSlide('left');
          }}
        />
      </div>
    );
  }
  return (
    <div className="segment-slider-container">
      <div ref={sliderWrapperRef} className="segment-slider-wrapper">
        {props.children}
      </div>
    </div>
  );
};

export default SegmentAutoSlider;
